<div
  class="tipo-de-obra-content titles"
  appDropdownToggle
  #dropdown="dropdownToggle"
  (click)="dropdown.toggle()"
>
  <div class="icon-text">
    <span class="icon-circle">
      <img
        class="img-icon"
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/feature_search.svg"
        alt=""
        width="22"
        height="22"
      />
    </span>

    <h2>Buscar somente</h2>
  </div>
  <a
    class="btn tipo-de-obra-link"
    data-bs-toggle="collapse"
    href="#btn-buscar-somente"
    role="button"
    aria-expanded="true"
    (click)="$event.stopPropagation(); dropdown.toggle()"
    (keydown.enter)="dropdown.toggle()"
    (keydown.space)="dropdown.toggle()"
  >
    <img
      class="img-icon"
      [ngClass]="{ 'girar-icon': dropdown.isOpen }"
      src="{{
        BASE_IMG_URL
      }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
      alt=""
      width="18"
      height="18"
    />
  </a>
</div>
<div
  class="collapse show check-total"
  id="btn-buscar-somente"
  *ngIf="dropdown.isOpen"
>
  <li *ngFor="let option of buscarSomenteObras; trackBy: trackById">
    <div class="form-check">
      <input
        type="checkbox"
        class="form-check-input checkbox"
          [(ngModel)]="option.checked"
        (change)="onCheckboxChange($event, option)"
       [class.disabled]="disabled" [disabled]="disabled"
        [id]="'buscar-somente-' + option.id"
        (click)="$event.stopPropagation()"
      />
      <label class="form-check-label" [for]="'buscar-somente-' + option.id">{{
        option["description"]
      }}</label>
    </div>
  </li>
</div>
